var React = require('react');

function Face (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.39453 0.287109H18.3945C19.4991 0.287109 20.3945 1.18254 20.3945 2.28711V18.2871C20.3945 19.3917 19.4991 20.2871 18.3945 20.2871H2.39453C1.28996 20.2871 0.394531 19.3917 0.394531 18.2871V2.28711C0.394531 1.18254 1.28996 0.287109 2.39453 0.287109ZM2.39453 2.28711V18.2871H18.3945V2.28711H2.39453ZM9.52759 10.2915H11.3945V16.2871H13.3945V10.2915H15.377V8.2915H13.3945V7.28711C13.3945 6.73482 13.8422 6.28711 14.3945 6.28711H15.3945V4.28711H14.3945C12.7377 4.28711 11.3945 5.63026 11.3945 7.28711V8.2915H9.52759V10.2915Z","fill":"white"}));
}

Face.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = Face;

Face.default = Face;
